import React, { useEffect } from 'react';
import { ScrollToTop } from './ScrollToTop';
import { AlertList as OldAlertList } from './AlertList';
import { AlertList as NewAlertList } from './AlertListV2';
import { useUIPreferencesStore } from '@/store/uiPreferencesStore';
import { AlertType } from '../types';
import { useQueryClient } from '@tanstack/react-query';

interface NewAlertsProps {
  type: AlertType;
  setUnassignedCountOverride: (count: number) => void;
}

const NewAlerts: React.FC<NewAlertsProps> = ({ type, setUnassignedCountOverride }) => {
  const { useNewAlertSorting } = useUIPreferencesStore();
  const queryClient = useQueryClient();

  // When the alert sorting method changes, invalidate related queries to force a refresh
  useEffect(() => {
    queryClient.invalidateQueries({ queryKey: ['alerts', type] });
  }, [useNewAlertSorting, queryClient, type]);

  return (
    <div className="relative">
      {useNewAlertSorting ? <NewAlertList type={type} onCountChange={setUnassignedCountOverride} /> : <OldAlertList type={type} onCountChange={setUnassignedCountOverride} />}
      <ScrollToTop />
    </div>
  );
};

export default NewAlerts;
